(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nether-benefit-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // A tap on a card the row only partly shows slides it into view (2026-10-23). Clarity showed ad
    // visitors tapping the peeking Trail Grip / Valley Pouch cards; the row only answered to a swipe.
    document.addEventListener('click', function (e) {
      var card = e.target instanceof Element && e.target.closest('.nether-bcards__card');
      if (!card) return;
      var track = card.closest('.nether-bcards__track');
      if (!track) return;
      var t = track.getBoundingClientRect();
      var c = card.getBoundingClientRect();
      if (c.left >= t.left - 1 && c.right <= t.right + 1) return;
      card.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', inline: 'start', block: 'nearest' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nether-film"] && !Shopify.designMode) return;
  try {
    
  /* Tap to play with sound; the cover and the length come back when it ends. */
  if (!customElements.get('nether-film')) {
    customElements.define('nether-film', class extends HTMLElement {
      connectedCallback() {
        const video = this.querySelector('video');
        const play = this.querySelector('.nether-film__play');
        if (!video || !play) return;
        play.addEventListener('click', () => {
          this.setAttribute('playing', '');
          video.controls = true;
          video.muted = false;
          video.play().catch(() => {
            this.removeAttribute('playing');
            video.controls = false;
          });
        });
        video.addEventListener('ended', () => {
          this.removeAttribute('playing');
          video.controls = false;
          video.load();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nether-size-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nsp]').forEach(function (root) {
    // Unit toggle: swap the in/lb and cm/kg spans.
    root.querySelectorAll('[data-nsp-unit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var unit = btn.getAttribute('data-nsp-unit');
        root.setAttribute('data-unit', unit);
        // Matched on the ATTRIBUTE, not on object identity. There are two
        // unit toggles on the page now — one in the finder card, one on the
        // chart — and `b === btn` would have lit the clicked button while
        // switching the other toggle's matching button OFF, so the two would
        // have disagreed on screen about a state they actually share.
        root.querySelectorAll('[data-nsp-unit]').forEach(function (b) {
          var on = b.getAttribute('data-nsp-unit') === unit;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-nsp-in]').forEach(function (el) { el.hidden = unit !== 'in'; });
        root.querySelectorAll('[data-nsp-cm]').forEach(function (el) { el.hidden = unit !== 'cm'; });
      });
    });

    // Gift module: jeans size -> chart row. Ranges parse from the rendered
    // inch spans so this can never disagree with the table above it. A jeans
    // waist at a row boundary maps UP — pants understate real waist.
    function chart() {
      var rows = [];
      root.querySelectorAll('tbody tr[data-nsp-size]').forEach(function (tr) {
        var size = tr.getAttribute('data-nsp-size');
        var inEl = tr.querySelector('[data-nsp-in]');
        var cmEl = tr.querySelector('[data-nsp-cm]');
        var txt = inEl ? inEl.textContent : '';
        var m = txt.match(/(\d+(?:\.\d+)?)\s*[-–]\s*(\d+(?:\.\d+)?)/);

        // WEIGHT, read from the cell tagged data-nsp-weight. Aimed at the cell
        // rather than at the row's spans, because both cells use the same
        // in/cm attributes and a row-level lookup always returns waist.
        var wCell = tr.querySelector('[data-nsp-weight]');
        var wInEl = wCell ? wCell.querySelector('[data-nsp-in]') : null;
        var wCmEl = wCell ? wCell.querySelector('[data-nsp-cm]') : null;
        var wTxt = wInEl ? wInEl.textContent : '';
        // The top row reads "240-300+ lb", so the open end is matched loosely
        // and the "+" simply means there is no ceiling above it.
        var wm = wTxt.match(/(\d+(?:\.\d+)?)\s*[-–]\s*(\d+(?:\.\d+)?)/);

        if (size && m) {
          rows.push({
            size: size,
            min: parseFloat(m[1]),
            max: parseFloat(m[2]),
            labelIn: txt.trim(),
            labelCm: cmEl ? cmEl.textContent.trim() : '',
            wMin: wm ? parseFloat(wm[1]) : null,
            wMax: wm ? parseFloat(wm[2]) : null,
            wLabelIn: wTxt.trim(),
            wLabelCm: wCmEl ? wCmEl.textContent.trim() : ''
          });
        }
      });
      return rows;
    }

    // The band quoted back has to be in the unit the visitor is looking at.
    // chart() parses the inch spans because they are the only ones the ranges
    // can be read from, so the cm string is carried alongside and chosen here.
    function bandLabel(row) {
      if (root.getAttribute('data-unit') === 'cm' && row.labelCm) return row.labelCm;
      return row.labelIn;
    }

    // Shared row lookup. A measurement at a boundary maps to the row it starts,
    // and anything past either end clamps to the first or last row rather than
    // returning nothing.
    function rowFor(value, rows) {
      if (!rows.length) return null;
      if (value <= rows[0].min) return rows[0];
      if (value >= rows[rows.length - 1].max) return rows[rows.length - 1];
      for (var i = 0; i < rows.length; i++) {
        if (value >= rows[i].min && value < rows[i].max) return rows[i];
      }
      return rows[Math.floor(rows.length / 2)];
    }

    function highlight(size) {
      root.querySelectorAll('tbody tr[data-nsp-size]').forEach(function (tr) {
        tr.classList.toggle('is-hit', tr.getAttribute('data-nsp-size') === size);
      });
    }

    /* ONE RENDERER FOR BOTH ROUTES (rebuilt 2026-08-23).

       The tape calculator and the jeans-size pills used to each print their
       own sentence into their own <p>, a long way apart, which meant the page
       could show two live answers at once — and if they disagreed, the visitor
       had no way to tell which one was current. Both now write into the single
       answer card, so there is exactly one answer on the page at any moment.

       size   the letter, at display scale
       bands  the ranges it was matched on, so the answer shows its working
       note   the reason, only when there is one worth giving
    */
    /* NO ANSWER UNTIL THEY HAVE ACTUALLY ENTERED SOMETHING (owner 2026-08-23:
       "it shouldn't be prefilled for a size... the size itself that shows up
       shouldn't be preselected for somebody").

       The card used to compute on load, so it opened already declaring a size
       against dials nobody had touched. That is a recommendation the visitor
       did not make and cannot tell apart from one they did, which is worse than
       showing nothing: it invites them to accept a number that came from a
       default.

       The handles still start somewhere, because a slider with no position is
       not a control. They start at the MIDPOINT of their own range rather than
       on a typical body, so the starting position reads as the middle of a
       scale instead of as a guess about them.

       One flag, set by the first real interaction with either dial. The unit
       link deliberately does not set it: switching to metric is not entering a
       measurement. */
    var touched = false;
    var answer = root.querySelector('[data-nsp-answer]');

    /* The asking state: no answer, no chart row highlighted. Called once on
       load and never again — the answer now latches on the first drag and
       tracks the dials from there. */
    function retract() {
      highlight(null);
    }
    var answerNote = root.querySelector('[data-nsp-answer-note]');
    var answerCta = root.querySelector('[data-nsp-answer-cta]');
    var answerResult = root.querySelector('[data-nsp-answer-size]');

    /* Resolving is a change of emphasis on a block that is already there, not a
       block appearing. The letters that do not match collapse and fade; the one
       that does is left standing at the left rail at full contrast.

       ONE WAY ONLY, per spec: once resolved the block never returns to the
       muted row for the rest of the session. Dragging past a boundary swaps
       which letter is lit, and that is the only thing that changes after the
       first touch. */
    /* WHERE IN THE BAND, IN WORDS (2026-08-26).

       The concept canvas had a version of this that drew the estimate as a pin
       on a banded waist scale and quoted the number under it — "34.3 in". It
       read well and it was rejected for a good reason: that decimal is a
       precision the visitor never gave us and the formula does not actually
       have. It is a regression line over height and weight, not a measurement.

       So the same useful fact — you are near an edge, and here is which way to
       go — is said in words, with no invented number. Someone dead centre in a
       band is told so too, because "comfortably inside M" is the reassurance
       that stops them second-guessing a good answer.

       This also absorbs the standing "Between sizes? Size up." advisory that
       used to print under the old chart for everyone regardless of where they
       landed. */
    /* The size, said as a word (owner 2026-08-26: "do the whole size").

       "M" is a garment tag; "Medium" is what someone says out loud when asked
       what they wear. The letter is still doing the identifying work in the
       chart row right below, so spelling it out in the sentence costs nothing
       and stops the verdict reading like a label.

       Sizes come from editor blocks, so anything not in the map falls through
       to whatever the block is called. A row added as "3XL" keeps saying
       "3XL" rather than breaking the sentence. */
    var SIZE_WORDS = {
      XS: 'Extra Small',
      S: 'Small',
      M: 'Medium',
      L: 'Large',
      XL: 'Extra Large',
      /* Owner 2026-08-26: "don't put extra extra large in there, that seems
         weird. Just do XX and then large." XL keeps the spelled-out form; XXL
         is the only one where the words stop helping. */
      XXL: 'XX Large'
    };
    function sizeWord(size) {
      return SIZE_WORDS[String(size).toUpperCase()] || size;
    }

    function edgeNote(est, row, rows) {
      var span = row.max - row.min;
      if (!(span > 0)) return 'Estimated from height and weight.';

      var at = (est - row.min) / span;
      var i = rows.indexOf(row);
      var up = i > -1 && i < rows.length - 1 ? rows[i + 1] : null;
      var down = i > 0 ? rows[i - 1] : null;

      /* Two short sentences, no dash (owner: "no em dash in that top copy
         section"). A dash here was doing the job a full stop does better —
         the second clause is an instruction, not an aside. */
      if (at >= 0.75 && up) {
        return 'Near the top of ' + sizeWord(row.size) + '. Take ' + sizeWord(up.size) + ' if you like it looser.';
      }
      if (at <= 0.25 && down) {
        return 'Near the bottom of ' + sizeWord(row.size) + '. Take ' + sizeWord(down.size) + ' for a closer fit.';
      }

      /* OFF THE END OF THE CHART. rowFor() clamps anything past either end to
         the first or last row, which is the right answer — there is nothing
         smaller than Small to sell them — but it means `at` can land outside
         0..1 with no neighbour to point at, and the middle case would then
         tell someone who is under the smallest band that they are
         "comfortably inside" it. They are not; they are at the edge of what
         the range covers, and saying so is the honest version. */
      if (at < 0) return 'At the smaller end of ' + sizeWord(row.size) + '.';
      if (at > 1) return 'At the larger end of ' + sizeWord(row.size) + '.';

      return 'Comfortably inside ' + sizeWord(row.size) + '.';
    }

    function showAnswer(size, note) {
      if (!answer) return;
      answer.classList.add('is-resolved');
      /* A SENTENCE, NOT A LETTER. A bare "M" needed a caps label above it to
         say what it was; "You wear M." says it itself, which is what let the
         label go. */
      if (answerResult) answerResult.textContent = 'You wear size ' + sizeWord(size) + '.';
      /* answerNote is no longer rendered; the guard keeps this safe if the
         paragraph is ever put back from the editor. */
      if (answerNote) {
        if (note) answerNote.textContent = note;
        answerNote.classList.add("is-shown");
      }
      // The button says what it does. "Shop" alone beside a large letter reads
      // as a generic link; naming the size makes the answer and the action the
      // same object.
      if (answerCta) {
        answerCta.textContent = 'Shop size ' + size;
        answerCta.classList.add('is-resolved');
      }
      highlight(size);
    }

    /* ===================================================================
       THE CALCULATOR, LIVE (rebuilt 2026-08-23).

       Two dials, each a display-scale number with a slider under it, both
       writing the same value. No submit step: every change recomputes and the
       answer card updates in place.

       BOUNDS LIVE HERE, ONCE. They used to be written twice as inline
       literals — once in syncCalcUnit to set the input min/max, once again in
       runCalc to validate — which is two places to disagree. The slider needs
       the same numbers a third time, so they are now a single table that the
       sliders, the clamping and the messages all read from.
       =================================================================== */
    /* Bounds match the PDP sheet's sliders exactly (58-84 in, 90-350 lb), so a
       visitor who uses one surface and then the other never finds a different
       range. Sliders always hold IMPERIAL internally; the unit link only
       changes how the value is printed. That keeps one number in play and puts
       the conversion in exactly one place, the formatter. */
    var H_MIN = 58, H_MAX = 84, W_MIN = 90, W_MAX = 350;

    var rangeHeight = root.querySelector('[data-nsp-range-height]');
    var rangeWeight = root.querySelector('[data-nsp-range-weight]');
    var heightOut = root.querySelector('[data-nsp-height-display]');
    var weightOut = root.querySelector('[data-nsp-weight-display]');

    function metric() { return root.getAttribute('data-unit') === 'cm'; }

    /* THE SHARED ESTIMATOR. Identical to estWaistIn in
       blocks/nether-size-guide.liquid — height and weight in, an estimated
       waist in inches out, which is then read against the SAME Size row blocks
       the table below renders. Copying the coefficients rather than importing
       them is the one duplication here, and it is deliberate: the PDP block is
       welded to the buy area and cannot be rendered on a content page. If these
       numbers are ever retuned, both files have to move together. */
    function estWaistIn(hIn, wLb) {
      return Math.min(50, Math.max(26, (0.082 * wLb) + (0.18 * hIn) + 6.5));
    }

    function fmtHeight(inches) {
      if (metric()) return Math.round(inches * 2.54) + ' cm';
      return Math.floor(inches / 12) + "' " + Math.round(inches % 12) + '"';
    }

    function fmtWeight(lb) {
      if (metric()) return Math.round(lb / 2.20462) + ' kg';
      return Math.round(lb) + ' lb';
    }

    /* Paints the slider's filled portion. A range input cannot express
       "how far along am I" in CSS on its own, so the script hands it a
       percentage and the stylesheet draws the fill from that. */
    function paint(range) {
      if (!range) return;
      var min = parseFloat(range.min), max = parseFloat(range.max);
      range.style.setProperty('--nsp-fill', ((parseFloat(range.value) - min) / (max - min)) * 100 + '%');
    }

    var ends = {
      hMin: root.querySelector('[data-nsp-height-min]'),
      hMax: root.querySelector('[data-nsp-height-max]'),
      wMin: root.querySelector('[data-nsp-weight-min]'),
      wMax: root.querySelector('[data-nsp-weight-max]')
    };

    function render() {
      if (heightOut && rangeHeight) heightOut.textContent = fmtHeight(parseFloat(rangeHeight.value));
      if (weightOut && rangeWeight) weightOut.textContent = fmtWeight(parseFloat(rangeWeight.value));
      /* The ends are formatted by the same two functions as the value, so they
         cannot fall out of step with it when the unit changes. */
      if (ends.hMin) ends.hMin.textContent = fmtHeight(H_MIN);
      if (ends.hMax) ends.hMax.textContent = fmtHeight(H_MAX);
      if (ends.wMin) ends.wMin.textContent = fmtWeight(W_MIN);
      if (ends.wMax) ends.wMax.textContent = fmtWeight(W_MAX);
      paint(rangeHeight);
      paint(rangeWeight);
    }

    /* The answer. Height and weight give an ESTIMATED waist, which is then read
       against the chart below — so the size the calculator names and the row it
       highlights are always the same row, and the chart stays the single source
       of the numbers. */
    function runCalc() {
      if (!touched) return;
      if (!rangeHeight || !rangeWeight) return;

      var hIn = parseFloat(rangeHeight.value);
      var wLb = parseFloat(rangeWeight.value);
      if (isNaN(hIn) || isNaN(wLb)) return;

      var rows = chart();
      if (!rows.length) return;

      var est = estWaistIn(hIn, wLb);
      var row = rowFor(est, rows);
      if (!row) return;

      showAnswer(row.size, edgeNote(est, row, rows));
    }

    /* The quoted waist band and the sizing-up guidance that used to print here
       are gone (owner spec v2: "Explainer is one line, and only after resolve".
       "Thigh sizing note moves into the size chart link"). The band is still
       visible — the matched row highlights in the chart below, which is where
       someone checking the working will look anyway. */

    // ---- wiring -------------------------------------------------------
    /* LIVE FROM THE FIRST DRAG. `touched` latches true on the first input and
       never goes back, so the answer appears once the visitor has actually
       moved something and then simply tracks the dials. Retracting on each
       drag — which is what the submit build did — would mean the answer
       vanished the moment you tried to adjust toward it. */
    [rangeHeight, rangeWeight].forEach(function (range) {
      if (!range) return;
      range.addEventListener('input', function () {
        touched = true;
        render();
        runCalc();
      });
    });

    /* THE UNIT LINK. Converts the values it is holding rather than resetting
       them: someone who has dialled in 34 inches and then switches to metric
       means 86cm, not "start again". */
    var unitToggle = root.querySelector('[data-nsp-unit-toggle]');
    var unitLabel = root.querySelector('[data-nsp-unit-label]');

    function setUnit(next) {
      if ((next === 'cm') === metric()) return;

      /* The sliders never change: they hold inches and pounds whatever the
         toggle says. Only the printed readouts and the chart's own columns
         switch, so there is nothing to convert and re-clamp here — which is
         also what stops a value drifting a little on every round trip. */
      root.setAttribute('data-unit', next);
      root.querySelectorAll('[data-nsp-in]').forEach(function (el) { el.hidden = next !== 'in'; });
      root.querySelectorAll('[data-nsp-cm]').forEach(function (el) { el.hidden = next !== 'cm'; });

      render();
      if (unitLabel) unitLabel.textContent = next === 'cm' ? 'Use in / lb' : 'Use cm / kg';
      if (unitToggle) unitToggle.setAttribute('aria-pressed', next === 'cm' ? 'true' : 'false');
      runCalc();
    }

    if (unitToggle) {
      unitToggle.addEventListener('click', function () {
        setUnit(metric() ? 'in' : 'cm');
      });
    }

    // The chart's own toggle still exists for anyone who scrolls straight to
    // the table, and it drives the same path.
    root.querySelectorAll('[data-nsp-unit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setUnit(btn.getAttribute('data-nsp-unit'));
      });
    });

    // First paint positions the handles and paints their tracks. It does NOT
    // answer: runCalc returns early until `touched`.
    render();
    retract();

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nether-timeline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.tlReady) return;
      root.dataset.tlReady = '1';

      const rail = root.querySelector('[data-tl-rail]');
      const slides = [...root.querySelectorAll('[data-tl-slide]')];
      const dots = [...root.querySelectorAll('[data-tl-dot]')];
      const labels = [...root.querySelectorAll('[data-tl-lab]')];
      const track = root.querySelector('[data-tl-labels]');
      if (!rail || slides.length < 2 || !track) return;

      // Slot width must match the CSS flex-basis. Read it rather than repeat
      // the number here, so changing the CSS cannot silently desync the track.
      const slot = () => parseFloat(getComputedStyle(labels[0]).width) || 0;

      // One video per slide, played only while its slide is the active one.
      // preload="none" in the markup means nothing downloads until we ask, so
      // four off-screen videos cost nothing on a phone.
      const videos = slides.map((s) => s.querySelector('[data-tl-video]'));
      const still = matchMedia('(prefers-reduced-motion: reduce)');

      const roll = (i) => {
        videos.forEach((v, n) => {
          if (!v) return;
          if (n === i && !still.matches) {
            const go = v.play();
            if (go && go.catch) go.catch(() => {});
          } else {
            v.pause();
            v.classList.remove('is-playing');
          }
        });
      };

      videos.forEach((v) => {
        if (!v) return;
        // 'playing' rather than 'play': only reveal once frames are actually
        // arriving, otherwise the fade uncovers a blank element on slow data.
        v.addEventListener('playing', () => v.classList.add('is-playing'));
        v.addEventListener('pause', () => v.classList.remove('is-playing'));
      });

      let current = -1;
      const paint = (i) => {
        if (i === current) return;
        current = i;
        roll(i);
        dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
        labels.forEach((l, n) => l.classList.toggle('is-on', n === i));
        const wrap = track.parentElement.clientWidth;
        const offset = (wrap - slot()) / 2 - i * slot();
        track.style.transform = 'translateX(' + Math.round(offset) + 'px)';
      };

      // IntersectionObserver against the rail, not the viewport: the active
      // slide is the one nearest the rail's own centre, which stays correct
      // while the page scrolls vertically past a half-swiped carousel.
      //
      // RATIOS ARE KEPT PER SLIDE, NOT READ OFF `entries`. The callback is only
      // handed the slides whose intersection CROSSED A THRESHOLD on that tick --
      // not every slide currently on screen. So when slide 2 edged into view
      // while slide 1 sat steady at full visibility, slide 1 was absent from
      // `entries` entirely and slide 2 won by default: the rail showed
      // "March 2023" while the scrubber underneath read "A week later".
      // Holding the last known ratio for every slide and picking the maximum
      // across all of them is what makes the comparison honest.
      const ratios = new Array(slides.length).fill(0);

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            const n = slides.indexOf(e.target);
            if (n > -1) ratios[n] = e.isIntersecting ? e.intersectionRatio : 0;
          });
          // Ties go to the earliest slide, which is what you want on a wide
          // desktop where two or three cards are fully visible at once.
          let best = -1;
          let bestRatio = 0;
          for (let n = 0; n < ratios.length; n += 1) {
            if (ratios[n] > bestRatio) {
              bestRatio = ratios[n];
              best = n;
            }
          }
          if (best > -1) paint(best);
        },
        // 0 included so a slide leaving the rail reports itself out; without it
        // a departing slide keeps its last ratio forever.
        { root: rail, threshold: [0, 0.25, 0.5, 0.75, 1] }
      );
      slides.forEach((s) => io.observe(s));

      paint(0);
      addEventListener('resize', () => { const i = current; current = -1; paint(i); }, { passive: true });
    };

    const boot = () => document.querySelectorAll('[data-nether-timeline]').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    // Theme editor re-renders a section without a full page load.
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
